import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedApiService } from '../../../shared/service/util.service';
import { SponserModel } from '../Model/sponser.model';

@Injectable({
  providedIn: 'root'
})
export class SponserService {

  private endpoint = `Sponsor/GetAll`

  private sharedApiService = inject(SharedApiService)

  getAll(): Observable<{ value: SponserModel[] }> {
    return this.sharedApiService.getAll(this.endpoint);
  }

  getById(id: number): Observable<{ value: SponserModel[] }> {
    return this.sharedApiService.getById('Sponsor/GetSponsorById', id);
  }
}
